/*
 * SiteAmbient v2 — the one background the whole site shares.
 *
 * Maestro's field, flat and neutral: graphite #11161c with a faint engineering
 * grid and a soft top light. The old deep-blue gradient, the blue dot grid and
 * the site-wide orb canvas are gone; color now belongs to content accents
 * (pyramid 1 / 10 / 19) and motion belongs to each page's own moment.
 * Pages set their root to `relative isolate bg-transparent`.
 */
const SiteAmbient = () => (
  <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
    {/* flat graphite field */}
    <div className="absolute inset-0" style={{ background: '#11161c' }} />
    {/* faint neutral grid, the drafting-table texture */}
    <div
      className="absolute inset-0 opacity-[0.05]"
      style={{
        backgroundImage:
          'linear-gradient(rgba(232,236,242,0.55) 1px, transparent 1px), linear-gradient(90deg, rgba(232,236,242,0.55) 1px, transparent 1px)',
        backgroundSize: '56px 56px',
      }}
    />
    {/* soft top light so panels seat instead of floating in void */}
    <div
      className="absolute inset-0"
      style={{ background: 'radial-gradient(90% 55% at 50% -10%, rgba(232,236,242,0.055) 0%, transparent 60%)' }}
    />
  </div>
)

export default SiteAmbient
